import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { useIsNativeTabBarEnabled } from 'hooks/use-is-native-tab-bar-enabled';

/**
 * The native (Liquid Glass) tab bar floats over content instead of reserving its own space,
 * so a screen's last scrollable content can end up hidden behind it. Spread this into a
 * screen's root ScrollView/FlatList `contentContainerStyle` as `paddingBottom` to reserve
 * real scroll space for it.
 *
 * `NativeTabs.Trigger`'s own `contentStyle.paddingBottom` does NOT work for this: it's
 * composed at the native level, outside RN's layout tree, so it paints an opaque strip over
 * existing content instead of shrinking the space RN lays content out into.
 */
export const useNativeTabBarContentInset = (): number => {
  const { bottom: safeAreaBottomInset } = useSafeAreaInsets();
  const isNativeTabBarEnabled = useIsNativeTabBarEnabled();

  return isNativeTabBarEnabled ? safeAreaBottomInset : 0;
};
